import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 100%;
  background: none;
  margin: var(--spacing-0);
  box-sizing: content-box;
`;

export const ProgressBarDisplay = styled.ul`
  padding: ${({ isLandscape }) =>
    isLandscape ? 'var(--spacing-0)' : 'var(--spacing-5) var(--spacing-7)'};
`;
